import { Account } from "./types";

export const getSelfHref = (account?: Account): string | undefined =>
  account?.links.find((link) => link.rel === "self")?.href;
